import {
  GET_ACTIVE_ALERT_REQUEST,
  GET_ACTIVE_ALERT_SUCCESS,
  GET_ACTIVE_ALERT_FAILURE,
  GET_ALERT_SETTINGS_REQUEST,
  GET_ALERT_SETTINGS_SUCCESS,
  GET_ALERT_SETTINGS_FAILURE,
  UPDATE_ALERT_SETTINGS_REQUEST,
  UPDATE_ALERT_SETTINGS_SUCCESS,
  UPDATE_ALERT_SETTINGS_FAILURE,
  DISMISS_ALERT
} from "../actions/actionsCreators";

const initialState = {
  activeAlert: null,
  alertSettings: null,
  isDismissed: false,
  loading: false,
  updating: false,
  error: null
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_ALERT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ACTIVE_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        activeAlert: action.payload,
        isDismissed: false
      };
    case GET_ACTIVE_ALERT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    case GET_ALERT_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ALERT_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        alertSettings: action.payload
      };
    case GET_ALERT_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    case UPDATE_ALERT_SETTINGS_REQUEST:
      return {
        ...state,
        updating: true,
        error: null
      };
    case UPDATE_ALERT_SETTINGS_SUCCESS:
      return {
        ...state,
        updating: false,
        alertSettings: action.payload,
        activeAlert: action.payload.isActive ? action.payload : null
      };
    case UPDATE_ALERT_SETTINGS_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      };
      
    case DISMISS_ALERT:
      return {
        ...state,
        isDismissed: true
      };
      
    default:
      return state;
  }
};

export default alertReducer;